<template>
  <sButton
    v-if="item && item.length"
    color="var(--white-color)"
    data-qa="start-analiz-ai"
    :loading="loading"
    type="border"
    @click="startAnalizAI">
    {{ $t('AIRequirements.StartAnalizAI') }}
  </sButton>
</template>
<script>
import { eventBus } from '@/main'

import AiApi from '@/api/aiApi'
const aiApi = new AiApi()

export default {
  name: 'StartAnalizAI',
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    startAnalizAI() {
      if (!this.item?.length) {
        return
      }
      this.loading = true
      aiApi.checkSupplierDocuments({
        tenderId: this.tenderId,
        organizationIds: this.item.map(el => el.bidderInfo.organizationId)
      })
        .then(() => {
          this.$emit('startAnalizAI')
          eventBus.$emit('offerTab_getRequirements', {tenderId: this.tenderId} )
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  props: {
    tenderId: {
      type: Number,
    },
    item: {
      type: Array,
    }
  },
}
</script>